import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "../StatusCard";
import { MetricCard } from "../MetricCard";
import { HealthBadge } from "../HealthBadge";
import { QueryStateBoundary } from "../QueryStateBoundary";
import { useVersion, useBuildInfo } from "@/hooks/queries/useSystemInfo";
import { useLiveness } from "@/hooks/queries/useHealthStatus";

interface VersionPayload {
  data: {
    application_version: string;
    environment: string;
  };
}

interface BuildInfoPayload {
  data: {
    build_version: string;
  };
}

interface LivenessPayload {
  status: string;
}

export function SystemOverviewSection(): React.JSX.Element {
  const versionQuery = useVersion();
  const buildInfoQuery = useBuildInfo();
  const livenessQuery = useLiveness();

  return (
    <StatusCard title="System Overview">
      <Stack spacing={1.5}>
        <QueryStateBoundary query={versionQuery}>
          {(payload) => {
            const version = payload as unknown as VersionPayload;
            return (
              <>
                <MetricCard label="Backend Version" value={version.data?.application_version} />
                <MetricCard label="Environment" value={version.data?.environment} />
              </>
            );
          }}
        </QueryStateBoundary>
        <QueryStateBoundary query={buildInfoQuery}>
          {(payload) => {
            const build = payload as unknown as BuildInfoPayload;
            return <MetricCard label="Build Version" value={build.data?.build_version} />;
          }}
        </QueryStateBoundary>
        <QueryStateBoundary query={livenessQuery}>
          {(payload) => {
            const status = (payload as unknown as LivenessPayload).status;
            return (
              <MetricCard label="Application Status" render={<HealthBadge status={status} />} />
            );
          }}
        </QueryStateBoundary>
      </Stack>
    </StatusCard>
  );
}
